module.exports = __webpack_public_path__ + "media/views/about/images/mail-90855437588c3d041f6cc87857d15b7a.svg";